import { Component } from 'react';
import {
  DollarSign,
  Clock,
  CheckCircle,
  CreditCard,
  RefreshCw,
  Landmark,
  TrendingUp,
  TrendingDown,
  FileCheck,
  List,
  Ban,
  ShieldX,
} from 'lucide-react';
import '../../styles/components/client-due-card.scss';
import i18n from '../../i18n';
import { formatAmount } from '../../utils/common';

export class ClientAmountCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isRefreshing: false,
    };
  }

  handleRefresh = () => {
    this.setState({ isRefreshing: true });

    // Simulate API call
    setTimeout(() => {
      this.setState({ isRefreshing: false });
      if (this.props.onRefresh) {
        this.props.onRefresh(this.props.type);
      }
    }, 1000);
  };

  handlePayNow = () => {
    if (this.props.onPayNow) {
      this.props.onPayNow(this.props.amount, this.props.type);
    }
  };

  handleCardClick = () => {
    if (this.props.onSelect) {
      this.props.onSelect(this.props.type);
    }
  };

  getCardIcon = () => {
    const { type } = this.props;
    const iconProps = { className: 'card-icon-new' };

    switch (type) {
      case 'pending':
        return <Clock {...iconProps} color="#f59e0b" />;
      case 'pending_client':
        return <Clock {...iconProps} color="#f59e0b" />;
      case 'approved':
        return <CheckCircle {...iconProps} color="#16a34a" />;
      case 'fs_approved':
        return <CheckCircle {...iconProps} color="#16a34a" />;
      case 'pending_mzadcom':
        return <FileCheck {...iconProps} color="#f59e0b" />;
      case 'admin_approved':
        return <FileCheck {...iconProps} color="#f59e0b" />;
      case 'completed':
        return <FileCheck {...iconProps} color="#16a34a" />;
      case 'total':
        return <CreditCard {...iconProps} color="#2563eb" />;
      case 'paid':
        return <Landmark {...iconProps} color="#9333ea" />;
      case 'fundAdded':
        return <TrendingUp {...iconProps} color="#2563eb" />; // blue
      case 'fundDeduct':
        return <TrendingDown {...iconProps} color="#dc2626" />; // red
      case 'rejected':
        return <Ban {...iconProps} color="#dc2626" />; // red
      case 'admin_rejected':
        return <ShieldX {...iconProps} color="#dc2626" />; // red
      case 'finance_rejected':
        return <Ban {...iconProps} color="#dc2626" />; // red
      case 'deliverySettled':
        return <FileCheck {...iconProps} color="#9333ea" />; // purple
      case 'all':
        return <List {...iconProps} color="#1b8f9b" />; // teal
      default:
        return <DollarSign {...iconProps} color="#1b8f9b" />;
    }
  };

  render() {
    const {
      title,
      amount,
      type,
      selected,
      showPayButton,
      showRefreshButton,
      auctionCount,
      countLabel,
    } = this.props;

    const { isRefreshing } = this.state;

    const cardClasses = [
      'client-amount-card-new',
      //   type === 'paid' ? 'paid' : '',
      selected ? 'selected' : '',
    ]
      .filter(Boolean)
      .join(' ');

    const amountClasses = ['card-amount-new', type === 'paid' ? 'paid' : '']
      .filter(Boolean)
      .join(' ');

    return (
      <div className={cardClasses} onClick={this.handleCardClick}>
        <div>
          <div className="card-heade-newr">
            <h3 className="card-title-new">
              {this.getCardIcon()}
              {title}
            </h3>
            {showRefreshButton && (
              <button
                className={`refresh-btn-new ${isRefreshing ? 'spinning' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  this.handleRefresh();
                }}
              >
                <RefreshCw size={16} />
              </button>
            )}
          </div>

          <div className={amountClasses}>{formatAmount(amount)}</div>
        </div>
        {auctionCount !== undefined && (
          <div className="card-auction-new">
            {auctionCount} {countLabel || i18n.t('auctions')}
          </div>
        )}

        {showPayButton && (
          <div className="card-actions-new">
            <button
              className="pay-now-btn-new"
              onClick={(e) => {
                e.stopPropagation();
                this.handlePayNow();
              }}
            >
              {i18n.t('pay_now')}
            </button>
          </div>
        )}
      </div>
    );
  }
}
